import { jsx as l } from "react/jsx-runtime";
const o = (e) => /* @__PURE__ */ l("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1rem", height: "1rem", fill: "none", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ l(
  "path",
  {
    fill: "#212134",
    d: "M5.889 16H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .817.387v15.89a.5.5 0 0 1-.817.387L5.89 16h-.001Zm13.517 4.134-1.416-1.416A8.977 8.977 0 0 0 21 12a8.983 8.983 0 0 0-3.304-6.968l1.42-1.42A10.977 10.977 0 0 1 23 12c0 3.223-1.386 6.122-3.594 8.134Zm-3.543-3.543-1.422-1.422A3.992 3.992 0 0 0 16 12c0-1.43-.75-2.685-1.88-3.392l1.439-1.439A5.99 5.99 0 0 1 18 12c0 1.842-.83 3.49-2.137 4.591Z"
  }
) }), m = o;
export {
  m as default
};
